<template lang="pug">
  div.easy-footer
    p {{copyright}}
    p
      img(src="../assets/img/copy_right.png")
      span 备案京ICP备13015804号
</template>
<script>
export default {
  name: 'EasyFooter',
  data () {
    return {
      copyright: ''
    }
  },
  created () {
    this.copyright = `©2020-${(new Date().getFullYear())} zhiweidata.com`
  }
}
</script>
<style lang="scss" scoped>
  .easy-footer {
    font-size: 12px;
    color: #333;
    p{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      img{
        margin-right: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/components/EasyFooter.vue